angular.module('impactx.rfx').controller('RFXThreadListSupplierCtrl',
    RFXThreadListSupplierCtrl);

$inject = ["$routeParams", "selectedListItems", "$scope"];

function RFXThreadListSupplierCtrl($routeParams, selectedListItems, $scope)
{
    var ctrl = this;
    ctrl.supplierId = $routeParams.supplierId;
    ctrl.$onInit = function () {
        ctrl.conversation = $scope.trns.conversation;
        ctrl.unreadConversation = $scope.trns.unreadConversation;
    }

    this.canEdit = function () {
        return selectedListItems.isSingleSelection()
            && selectedListItems.getFirstSelectedItem().isSupport
            && selectedListItems.getFirstSelectedItem().isSupport.value == "0";
    };

    this.canEditSupport = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().isSupport
            && selectedListItems.getFirstSelectedItem().isSupport.value == "1";
    };

    this.getEditLink = function () {
        return "rfxthread/edit/supplier/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().rfqhid
            + "/" + $routeParams.supplierId
    };

    this.getEditLinkSupport = function () {
        return "rfxthread/edit/supplier/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().rfqhid
            + "/" + $routeParams.supplierId + "/true"
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getEditLink, type:'link', condition: ctrl.canEdit, process: 'RFXThreadSupplierList'},
        {label: "details", linkFunction: ctrl.getEditLinkSupport, type:'link', condition: ctrl.canEditSupport, process: 'RFXThreadSupplierList'}
    ];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfx-thread-supplier-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/thread/list/supplier',
        id: "rfxthreadlistsupplier",
        mainAction : {id:"new", link: "#/rfxthread/edit/supplier/0/" + $routeParams.id + "/" + $routeParams.supplierId, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition,
        excelExport: true,
        valuesInteger: [
            {
                name: "RFQHId",
                value: $routeParams.id
            },
            {
                name: "SupplierId",
                value: $routeParams.supplierId
            }
        ]
    };
    this.getMeta = function () {
        return this.meta;
    }
}